import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService, Employer } from '../../core/api.service';

@Component({
  selector: 'ch-employers',
  standalone: true,
  imports: [FormsModule, RouterLink],
  templateUrl: './employers.component.html'
})
export class EmployersComponent implements OnInit {
  employers: Employer[] = [];
  page = 1;
  pageSize = 10;
  total = 0;
  loading = false;
  saving = false;
  error = '';
  notice = '';
  form: Partial<Employer> = {
    company_name: '',
    business_location: ''
  };

  constructor(private readonly api: ApiService) {}

  ngOnInit(): void {
    this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    this.error = '';
    try {
      const result = await this.api.employers(this.page, this.pageSize);
      this.employers = result.items;
      this.total = result.total;
      this.loading = false;
    } catch {
      this.error = 'Could not load employers.';
      this.loading = false;
    }
  }

  async create(): Promise<void> {
    if (!this.form.company_name || !this.form.business_location || this.saving) return;
    this.saving = true;
    this.error = '';
    this.notice = '';
    try {
      await this.api.createEmployer(this.form);
      this.form = { company_name: '', business_location: '' };
      this.notice = 'Employer created. Upload all required documents to activate the company.';
      await this.load();
    } catch {
      this.error = 'Could not create employer.';
    } finally {
      this.saving = false;
    }
  }

  documentCount(employer: Employer): number {
    return [
      employer.registration_certificate_url,
      employer.kra_pin_url,
      employer.tax_compliance_url,
      employer.cr12_url,
      employer.signed_mou_url
    ].filter(Boolean).length;
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.total / this.pageSize));
  }

  async go(delta: number): Promise<void> {
    this.page = Math.min(this.totalPages, Math.max(1, this.page + delta));
    await this.load();
  }
}
